<div class="p-4 sm:p-6">

  <!-- HEADER -->
  <div class="mb-6">

    <h2 class="text-2xl font-bold text-[#0B0D5C]">
      {{ 'SETUP.DOCUMENTS.SETUP_TITLE' | translate }}
    </h2>

    <p class="text-sm text-gray-500 mt-1">
      {{ 'SETUP.DOCUMENTS.SELECT_MODULE' | translate }}
    </p>

  </div>

  <!-- MODULE LIST -->
  <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">

    <div
      *ngFor="let item of list"
      (click)="goToDocumentTypes(item)"
      class="group bg-white border border-gray-200 hover:border-indigo-300 rounded-2xl p-4 cursor-pointer hover:shadow-md transition-all duration-200"
    >

      <div class="flex items-center justify-between">

        <!-- LEFT -->
        <div class="flex items-center gap-3">

          <!-- ICON -->
          <div
            class="h-11 w-11 rounded-xl bg-indigo-50 flex items-center justify-center group-hover:bg-indigo-100 transition-all"
          >

            <svg
              class="h-5 w-5 text-indigo-600"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >

              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 12h6m-6 4h6M7 4h10a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2z"
              />

            </svg>

          </div>

          <!-- TEXT -->
          <div>

            <h3
              class="text-base font-semibold text-[#0B0D5C]"
            >
              {{ item.module | translate }}
            </h3>

            <p
              class="text-xs text-gray-500 mt-1"
            >
              {{ 'SETUP.DOCUMENTS.OPEN_DOCUMENT_SETUP' | translate }}
            </p>

          </div>

        </div>

        <!-- ARROW -->
        <div
          class="h-9 w-9 rounded-full bg-gray-100 group-hover:bg-indigo-600 flex items-center justify-center transition-all"
        >

          <svg
            class="h-4 w-4 text-gray-500 group-hover:text-white"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            viewBox="0 0 24 24"
          >

            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 5l7 7-7 7"
            />

          </svg>

        </div>

      </div>

    </div>

  </div>

</div>